/* RUB HUB — Mega menu panel fit (2026-10-25). Pairs with assets/rh-mega-menu-panel-tight.css.
   Drops each (now shrink-to-fit) panel from under its own menu item, centred on it, then clamps it
   16px inside the viewport. Sets --rhm-left / --rhm-tx on the panel; without this script the CSS
   falls back to centred under the bar. ROLLBACK: delete this script's line in snippets/meta-tags.liquid. */
(function () {
  var EDGE = 16;
  function fit(item) {
    var panel = item.querySelector(':scope > .rhm-panel');
    var root = item.closest('.rhm-root');
    if (!panel || !root || window.innerWidth < 1025) return;
    var rr = root.getBoundingClientRect();
    var ir = item.getBoundingClientRect();
    var pw = panel.offsetWidth;
    var left = ir.left + ir.width / 2 - pw / 2;
    left = Math.max(EDGE, Math.min(left, window.innerWidth - EDGE - pw));
    panel.style.setProperty('--rhm-left', Math.round(left - rr.left) + 'px');
    panel.style.setProperty('--rhm-tx', '0px');
  }
  function fitAll() {
    document.querySelectorAll('.rhm-root > .rhm-item.rhm-has-panel').forEach(fit);
  }
  function init() {
    fitAll();
    document.addEventListener('mouseover', function (e) {
      var it = e.target.closest && e.target.closest('.rhm-root > .rhm-item.rhm-has-panel');
      if (it && !it.contains(e.relatedTarget)) fit(it);
    }, true);
    document.addEventListener('focusin', function (e) {
      var it = e.target.closest && e.target.closest('.rhm-root > .rhm-item.rhm-has-panel');
      if (it) fit(it);
    }, true);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fitAll, 120); });
    window.addEventListener('load', fitAll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
